import Boolean16 from '@carbon/icons-react/es/boolean/16';
import Calendar16 from '@carbon/icons-react/es/calendar/16';
import Hashtag16 from '@carbon/icons-react/es/hashtag/16';
import ListChecked16 from '@carbon/icons-react/es/list--checked/16';
import RadioButtonChecked16 from '@carbon/icons-react/es/radio-button--checked/16';
import Star16 from '@carbon/icons-react/es/star/16';
import StringText16 from '@carbon/icons-react/es/string-text/16';
import TextAlignJustify16 from '@carbon/icons-react/es/text--align--justify/16';
import UserMultiple16 from '@carbon/icons-react/es/user--multiple/16';
import User16 from '@carbon/icons-react/es/user/16';
import { Space } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IconShell } from 'components/atoms/icon-shell';
import { FieldTypes } from 'components/organisms/module-settings/fields/types';
import { unreachable } from 'utils/unreachable';

export const fieldIcon = (type: FieldTypes): JSX.Element => {
  switch (type) {
    case FieldTypes.Boolean:
      return <Boolean16 />;
    case FieldTypes.Date:
      return <Calendar16 />;
    case FieldTypes.Number:
      return <Hashtag16 />;
    case FieldTypes.MultiSelect:
      return <ListChecked16 />;
    case FieldTypes.MultiUserSelect:
      return <UserMultiple16 />;
    case FieldTypes.SingleSelect:
      return <RadioButtonChecked16 />;
    case FieldTypes.SingleUserSelect:
      return <User16 />;
    case FieldTypes.Text:
      return <StringText16 />;
    case FieldTypes.MultiLineText:
      return <TextAlignJustify16 />;
    case FieldTypes.Rating:
      return <Star16 />;
    default:
      return unreachable(type);
  }
};

interface FieldProps {
  type: FieldTypes;
}

export const FieldOption: FC<FieldProps> = ({ type }) => (
  <Space size={0}>
    <IconShell size="xsmall" icon={fieldIcon(type)} />
    <FormattedMessage id={`settings.fields.type.${type}`} />
  </Space>
);
